export default {
  title: 'Terminal',
  stats: {
    terminal_battery_level: 'Niveau de batterie',
    terminal_battery_state: 'État de charge',
    auto_accept_orders: 'Accepter automatiquement les commandes',
  },
  auto_accept_orders_modal: {
    title: 'Voulez-vous accepter automatiquement les commandes ?',
    buttons: {
      activate: 'Activer',
      cancel: 'Annuler',
    },
  },
  feedback: {
    update_success: 'Mis à jour avec succès',
    update_failed: 'Échec de la mise à jour. Veuillez réessayer.',
  },
};
